<template>
  <NuxtLink v-bind="$attrs" :to="localePath(props.to)">
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">

const props = defineProps({
  to: {
    type: String,
    required: true,
  },
})
const { localePath } = useLanguage()
</script>
